import create from "zustand";

export interface LicenseStoreStruct {
	classroom: boolean;
	courses: boolean;
	hallPass: boolean;

	enableClassroom: () => void;
	disableClassroom: () => void;
	enableCourses: () => void;
	disableCourses: () => void;
	enableHallPass: () => void;
	disableHallPass: () => void;
}

export const useLicenseStore = create<LicenseStoreStruct>((set) => ({
	classroom: false,
	courses: false,
	hallPass: false,

	enableClassroom: () => set(() => ({ classroom: true })),
	disableClassroom: () => set(() => ({ classroom: false })),
	enableCourses: () => set(() => ({ courses: true })),
	disableCourses: () => set(() => ({ courses: false })),
	enableHallPass: () => set(() => ({ hallPass: true })),
	disableHallPass: () => set(() => ({ hallPass: false })),
}));
